/**
 * AndVRadialBar - 径向条形图组件
 * 基于 Ant Design Charts RadialBar
 */
import React from 'react';
import { RadialBar } from '@ant-design/plots';
import { withBaseChart } from '../base/BaseChart';
import type { AndVRadialBarProps } from '../base/types';

const DEFAULT_RADIAL_BAR_DATA = [
  { name: '指标一', star: 5 },
  { name: '指标二', star: 4.5 },
  { name: '指标三', star: 4 },
  { name: '指标四', star: 3.5 },
  { name: '指标五', star: 3 },
];

const RadialBarWithBase = withBaseChart<AndVRadialBarProps>(RadialBar, {
  chartType: 'AndVRadialBar',
  defaultHeight: 300,
  defaultData: DEFAULT_RADIAL_BAR_DATA,
});

export const AndVRadialBar: React.FC<AndVRadialBarProps> = (props) => {
  const {
    xField = 'name',
    yField = 'star',
    colorField,
    seriesField,
    startAngle,
    maxAngle,
    radius,
    innerRadius,
    ...baseProps
  } = props;

  const chartProps: Record<string, unknown> = {
    ...baseProps,
    xField,
    yField,
  };

  if (colorField) chartProps.colorField = colorField;
  if (seriesField) chartProps.seriesField = seriesField;
  if (startAngle !== undefined) chartProps.startAngle = startAngle;
  if (maxAngle !== undefined) chartProps.maxAngle = maxAngle;
  if (radius !== undefined) chartProps.radius = radius;
  if (innerRadius !== undefined) chartProps.innerRadius = innerRadius;

  return <RadialBarWithBase {...chartProps} />;
};

export type { AndVRadialBarProps };
export default AndVRadialBar;
